module.exports = __webpack_public_path__ + "media/app/assets/races/draenei_female-175144ae36de7d24c903468556ad042f.png";